export enum StatusEnum {
    ADHERENT = "Adhérent",
    PROSPECT = "Prospect",
    ANNULE = "Contrat clos",
    ARAFRAICHIR = "A rafraichir",
    SANSSUITE = "Sans suite",
    MISSIONSPONCTUELLES = "Missions ponctuelles"
  }